import React, { useState } from "react";
import { supabase } from "./supabase";

const CANCELLATION_REASONS = [
  { value: "no_show", label: "Pasien tidak datang" },
  { value: "patient_cancel", label: "Pasien batal datang" },
  { value: "patient_reject_treatment", label: "Pasien menolak tindakan" },
  { value: "other", label: "Lainnya" },
];

export function CancellationButton({ visit, onSuccess }) {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Only show button for TERDAFTAR or PEMERIKSAAN status
  if (!visit || !["TERDAFTAR", "PEMERIKSAAN"].includes(visit.visit_status)) {
    return null;
  }

  const handleCancel = async () => {
    if (!reason) {
      setError("Pilih alasan pembatalan");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error("User not authenticated");

      // Update visit status
      const { error: updateError } = await supabase
        .from("visits")
        .update({
          visit_status: "DIBATALKAN",
          cancellation_reason: reason,
          cancellation_notes: notes,
          cancelled_at: new Date().toISOString(),
          cancelled_by: user.id,
          updated_at: new Date().toISOString(),
        })
        .eq("id", visit.id);

      if (updateError) throw updateError;

      // Log activity
      await supabase.from("activity_logs").insert({
        user_id: user.id,
        action: "VISIT_CANCELLED",
        description: `Kunjungan ${visit.visit_number} dibatalkan. Alasan: ${reason}${notes ? `. Catatan: ${notes}` : ""}`,
      });

      setShowModal(false);
      setReason("");
      setNotes("");

      // Notify parent to refresh
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button onClick={() => setShowModal(true)} className="cancel-btn">
        Batalkan
      </button>

      <style>{`
       .cancel-btn {
        padding: 6px 16px;
        border-radius: 999px;
       background: #fef2f2;
       color: #dc2626;
       border: 1px solid #fecaca;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
       transition: all 0.15s ease;
       white-space: nowrap;
     }
     .cancel-btn:hover {
      background: #dc2626;
     color: white;
     border-color: #dc2626;
    }
`}</style>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Batalkan Kunjungan
            </h3>

            <div className="mb-4 p-3 bg-gray-50 rounded">
              <p className="text-sm text-gray-600">
                <strong>{visit.visit_number}</strong> —{" "}
                {visit.client?.name || "Unknown"}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Status: {visit.visit_status}
              </p>
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 text-sm rounded">
                {error}
              </div>
            )}

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Alasan Pembatalan
              </label>
              <select
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
              >
                <option value="">-- Pilih Alasan --</option>
                {CANCELLATION_REASONS.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </select>
            </div>

            {reason === "other" && (
              <div className="mb-4">
                <input
                  type="text"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Jelaskan alasan pembatalan"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
            )}

            <div className="flex gap-2">
              <button
                onClick={() => setShowModal(false)}
                disabled={loading}
                className="flex-1 px-3 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 text-sm font-medium disabled:opacity-50"
              >
                Batal
              </button>
              <button
                onClick={handleCancel}
                disabled={!reason || loading}
                className="flex-1 px-3 py-2 text-white bg-red-600 rounded hover:bg-red-700 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Membatalkan..." : "Batalkan Kunjungan"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
